export default __webpack_public_path__ + "static/media/des-6.7f35acbe.jpg";